import script from "./CartItems.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItems.vue?vue&type=script&setup=true&lang=js"

import "./CartItems.vue?vue&type=style&index=0&id=3ebc30e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebc30e6"]])

export default __exports__